import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import UnAuthenticatedScreen from './Component/UnAuthenticatedScreen'

const mapStateToProps = (state, ownProps) => {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      message: state.auth.message
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
      loginResponse: (response) => {
        dispatch(Actions.loginResponse(response)) 
      }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnAuthenticatedScreen)

